// extracted by mini-css-extract-plugin
export var footer = "_n6-5";
export var fulfillmentInput = "_n6-0";
export var shipDateInput = "_n6-1";
export var shipmentModal = "_n6-2";
export var shipmentModalContent = "_n6-3";
export var tableContainer = "_n6-4";